// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeProfileGetForAccountBody = {
  accountId: string;
};

export type typeProfileGetForAccountOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    profile: {
      accountId: string;
      username: string;
      displayName: string;
      photoUrl: string | null;
      isDiscoverable: boolean;
      favoriteTeamIds: string[];
    } | null;
    followState: "none" | "requested" | "following";
    followsYou: boolean;
  };
};

export type typeProfileGetForAccountOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeProfileGetForAccountOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeProfileGetForAccountOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaProfileGetForAccountBody = {
  type: "object",
  properties: { accountId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["accountId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createProfileGetForAccount(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaProfileGetForAccountBody);
  }

  return async function postProfileGetForAccount(
    payload: typeProfileGetForAccountBody,
  ): Promise<
    typeProfileGetForAccountOutput200 | typeProfileGetForAccountOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postProfileGetForAccount" failed before calling the network. #b1921c8d8221`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b1921c8d8221" },
        },
        data: null,
      } as typeProfileGetForAccountOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/profile/get-for-account`,
      httpMethod: "POST",
      options,
    })) as
      typeProfileGetForAccountOutput200 | typeProfileGetForAccountOutput400;
  };
}
